import { useEffect } from 'react'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { EventNames } from '../../types/misc.types'
import { FolioDetail } from '../../types/mutual-fund-detail.types'
import { FolioNumber } from '../../features/user-investment/components/investment/folio/FolioNumber'

export const FolioBottomSheet = ({
  onDismiss,
  ScreenName,
  folios
}: {
  onDismiss: () => void
  ScreenName: string
  folios: FolioDetail[]
}) => {
  const heading = 'Folio Numbers'

  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])

  return (
    <BottomSheetContent bottomSheetBodyClassName='!px-0' onDismiss={onDismiss}>
      <div className='flex flex-col border-b border-[#F0F4F7]'>
        <div className='flex flex-col px-5 pb-2'>
          <div className='text-[18px] font-[500] text-[#232323]'>{heading}</div>
        </div>
        <div className='flex flex-col w-full'>
          {folios?.map((folio, idx) => (
            <div key={`${folio?.folioNumber}-${idx}`} className='flex flex-col w-full'>
              <FolioNumber folioDetails={folio} isLast={idx === folios?.length - 1} />
            </div>
          ))}
        </div>
      </div>
    </BottomSheetContent>
  )
}
